module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_ad) ? _c('div', {
    staticClass: "Ad"
  }, [(_vm.show_close) ? _c('i', {
    staticClass: "close el-icon-close",
    on: {
      "click": function($event) {
        _vm.closeAd();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ad && _vm.image) ? _c('a', {
    attrs: {
      "target": _vm.ad.target,
      "href": _vm.ad.href
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image.http_path
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa49a5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_common/Ad.vue
// module id = 113
// module chunks = 15